import React, { useEffect } from "react";

// Css
import classes from "./AuthLayout.module.css";

// Img
import jioPhotosLogo from "../../assets/svg/jiophotos-logo-black.svg";
import jioSnapLogo from "../../assets/svg/Jiosnap.svg";
import authBannerImg from "../../assets/png/auth-banner-img-2x.png";
import logo from "../../assets/png/JioCloud-Logo.png";

import { Box, Stack, Typography } from "@mui/material";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Container, Text } from "@jds/core";

export default function AuthLayout(props) {
  const navigate = useNavigate();
  const bearerToken = localStorage.getItem("authToken");
  const refreshToken = localStorage.getItem("refreshToken");
  useEffect(() => {
    if (bearerToken && refreshToken) {
      navigate("/home");
    }
  }, []);
  return (
    <section className={classes.auth}>
      <div className={classes["auth__container"]}>
        <div className={classes["auth__banner-container"]}>
          <div className={classes["auth_banner-logo"]} mb="80px">
            <NavLink to="/">
              <Stack direction="row" gap={1} alignItems="center">
                <img
                  src={logo}
                  alt="jio photos logo"
                  style={{ width: "40px" }}
                />
                <div>
                  <Text text="JioPhotos" appearance="body-m-bold" />
                  <Text
                    text="storage partner JioAICloud"
                    appearance="body-xxs"
                  />
                </div>
              </Stack>
            </NavLink>
          </div>
          <div className={classes["auth__banner-content"]}>
            <Container direction="column" gap={16}>
              <Text appearance="heading-m">Start your journey with us</Text>
              <Text appearance="body-m" color="primary_grey_80">
                Join us for seamless pre and post-event content management.
                Create, customise, and effortlessly share event Photos.
              </Text>
            </Container>
          </div>
          <div className={classes["auth__banner-img-container"]}>
            <img
              src={authBannerImg}
              alt="gallery"
              className={classes["auth__banner-img"]}
            />
          </div>
        </div>
        <div className={classes["auth__form-container"]}>
          <Outlet />
        </div>
      </div>
    </section>
  );
}
